import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { AlertCircle } from '@factorialco/f0-react/icons/app'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import ShiftTime from './ShiftDetails/ShiftTime'
import ShiftTitle from './ShiftDetails/ShiftTitle'

export interface Props {
  shift: Shift
  templateTitle: string
  date: moment.Moment
  plannedBreaks: PlannedBreak[]
  minRestConflict?: boolean
}

const DailyShiftDetails = ({
  shift,
  templateTitle,
  date,
  plannedBreaks,
  minRestConflict = false,
}: Props) => {
  const { viewOptions } = useCurrentViewOptions()
  const {
    schedule: { showName, showCompactView },
  } = viewOptions
  const showCompacted = showCompactView || shift.isAnHourOrLessLong
  const hasNameOrTemplateTitle = !!shift.name || !!templateTitle

  return (
    <Box flexDirection="column" gap="s2">
      {showCompacted ? (
        hasNameOrTemplateTitle ? (
          <Box flexDirection="row" alignItems="center" gap="s2">
            {minRestConflict && <F0Icon icon={AlertCircle} size="sm" color="critical" />}
            <ShiftTitle shift={shift} templateTitle={templateTitle} />
          </Box>
        ) : (
          <ShiftTime shift={shift} date={date} plannedBreaks={plannedBreaks} />
        )
      ) : (
        <>
          {showName && (
            <Box flexDirection="row" alignItems="center" gap="s2">
              {minRestConflict && <F0Icon icon={AlertCircle} size="sm" color="critical" />}
              <ShiftTitle shift={shift} templateTitle={templateTitle} />
            </Box>
          )}
          <ShiftTime shift={shift} date={date} plannedBreaks={plannedBreaks} />
        </>
      )}
    </Box>
  )
}

export default observer(DailyShiftDetails)
